export default __webpack_public_path__ + "static/media/warning.61bd504a.svg";